import React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Modal, ModalBody } from "reactstrap";

//Import userImage
import userImage1 from "../../../assets/images/vessel9.png";
import QR from "../../../assets/images/qr.png";

const vesselDetails = [
  { label: "Categories", value: "Yellowfin Tuna, BlackMarlin" },
  { label: "Address", value: "No:65, Negombo" },
  { label: "Owner Name", value: "Chandrasiri Perera" },
  { label: "Fishing Methods", value: "Gillnet, Longline" },
  { label: "Call Sign", value: "4SF400" },
  { label: "Fishing Areas", value: "Arabian Sea" },
  { label: "Width", value: "40 feet" },
  { label: "Fuel Type", value: "Diesel" },
  { label: "Hull Material", value: "-" },
  { label: "License Category", value: "National" },
  { label: "Registered Date", value: "2022-11-20" },
  { label: "Views", value: "2574" },
];

const LeftSideContent = () => {
  const [modal, setModal] = useState(false);
  const openModal = () => setModal(!modal);
  return (
    <React.Fragment>
      <Col lg={4}>
        <Card className="side-bar">
          <CardBody className="p-4">
            <div className="candidate-profile text-center">
              <img
                src={userImage1}
                alt=""
                width="100%"
                style={{ borderRadius: '5px' }}
              />
              <h6 className="mb-0 mt-4 d-flex align-items-center gap-2">
                <span>IMULA0790CHW</span>
                <i
                  className="uil uil-qrcode-scan icon"
                  onClick={openModal}
                ></i>
              </h6>
              <p className="text-muted mb-4"></p>
              {/* <ul className="candidate-detail-social-menu list-inline mb-0">
                <li className="list-inline-item">
                  <Link to="#" className="social-link">
                    <i className="uil uil-twitter-alt"></i>
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link to="#" className="social-link">
                    <i className="uil uil-whatsapp"></i>
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link to="#" className="social-link">
                    <i className="uil uil-phone-alt"></i>
                  </Link>
                </li>
              </ul> */}
            </div>
          </CardBody>

          <CardBody className="candidate-profile-overview border-top p-4">
            <h6 className="fs-17 fw-medium mb-3">Profile Overview</h6>
            <ul className="list-unstyled mb-0">
              {vesselDetails.map((item, index) => (
                <li key={index}>
                  <div
                    className="d-flex justify-content-between align-items-center"
                    style={{ padding: '10px', paddingLeft: '0px' }}
                  >
                    <label className="text-dark mb-0">{item.label}</label>
                    <p className="text-muted mb-0">{item.value}</p>
                  </div>
                </li>
              ))}
            </ul>
          </CardBody>
          {/* <CardBody className="p-4 border-top">
            <h6 className="fs-17 fw-medium mb-3">Professional Skills</h6>
            <div className="d-flex flex-wrap align-items-start gap-1">
              <span className="badge bg-success-subtle text-success fs-13 mt-1">
                User Interface Design
              </span>
              <span className="badge bg-success-subtle text-success fs-13 mt-1">
                Web Design
              </span>
              <span className="badge bg-success-subtle text-success fs-13 mt-1">
                Responsive Design
              </span>
              <span className="badge bg-success-subtle text-success fs-13 mt-1">
                Mobile App Design
              </span>
              <span className="badge bg-success-subtle text-success fs-13 mt-1">
                UI Design
              </span>
            </div>
          </CardBody> */}
          {/* <CardBody className="candidate-contact-details p-4 border-top">
            <h6 className="fs-17 fw-medium mb-3">Contact Details</h6>
            <ul className="list-unstyled mb-0">
              <li>
                <div className="d-flex align-items-center mt-4">
                  <div className="icon bg-primary-subtle text-primary flex-shrink-0">
                    <i className="uil uil-envelope-alt"></i>
                  </div>
                  <div className="ms-3">
                    <h6 className="fs-14 mb-1">Email</h6>
                    <p className="text-muted mb-0">gabrielpalmer@gmail.com</p>
                  </div>
                </div>
              </li>
              <li>
                <div className="d-flex align-items-center mt-4">
                  <div className="icon bg-primary-subtle text-primary flex-shrink-0">
                    <i className="uil uil-map-marker"></i>
                  </div>
                  <div className="ms-3">
                    <h6 className="fs-14 mb-1">Address</h6>
                    <p className="text-muted mb-0">Dodge City, Louisiana</p>
                  </div>
                </div>
              </li>
              <li>
                <div className="d-flex align-items-center mt-4">
                  <div className="icon bg-primary-subtle text-primary flex-shrink-0">
                    <i className="uil uil-phone"></i>
                  </div>
                  <div className="ms-3">
                    <h6 className="fs-14 mb-1">Phone</h6>
                    <p className="text-muted mb-0">+1(452) 125-6789</p>
                  </div>
                </div>
              </li>
              <li>
                <div className="d-flex align-items-center mt-4">
                  <div className="icon bg-primary-subtle text-primary flex-shrink-0">
                    <i className="uil uil-skype-alt"></i>
                  </div>
                  <div className="ms-3">
                    <h6 className="fs-14 mb-1">Skype</h6>
                    <p className="text-muted mb-0">@gabrielpalmer</p>
                  </div>
                </div>
              </li>
            </ul>
          </CardBody> */}
          <Modal
            isOpen={modal}
            toggle={openModal}
            role="dialog"
            centered
          >
            <ModalBody className="p-5">
              <div className="position-absolute end-0 top-0 p-3">
                <button
                  type="button"
                  className="btn-close"
                  onClick={openModal}
                ></button>
              </div>
              <img
                src={QR}
                width="100%"
              />
            </ModalBody>
          </Modal>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default LeftSideContent;
